import { EnumDictionary } from '../../../utils';
import { ApplicationSource } from './application-source.enum';

export const ApplicationSourceTitle: EnumDictionary<ApplicationSource, string> = {
  [ApplicationSource.Web]: 'ウェブ　ー　登録済',
  [ApplicationSource.Messenger]: 'モバイル',
  [ApplicationSource.WebAnonymous]: 'ウェブ　ー　ゲスト',
};